 <bzg-tab-set *ngIf="tabs" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item *ngIf="tabs.Authorization" [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'SECURITY.SEC_LABEL.Authorization' | translate | uppercase}}">
      <security-authorization></security-authorization>
    </bzg-tab-item>
    <bzg-tab-item *ngIf="tabs.Authentication && showInfo" [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'SECURITY.SEC_LABEL.Authentication' | translate | uppercase}}">
      <security-authentication #securityAuthentication *ngIf="!enableNewTabAuthentication"></security-authentication>
      <security-authentication-refactor *ngIf="enableNewTabAuthentication" [enableNewTabAuthentication]="enableNewTabAuthentication"></security-authentication-refactor>
    </bzg-tab-item>
</bzg-tab-set>
